import { LogoutOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';

import { useLogout } from '../use-logout';

export const LogoutButton = observer(() => {
  const logoutResource = useLogout();
  const handleButtonClick = () => logoutResource.send();

  return (
    <Button
      loading={logoutResource.isLoading}
      icon={<LogoutOutlined />}
      onClick={handleButtonClick}
    >
      Выход
    </Button>
  );
});
